import { VIEW_TYPE, VIEW_TYPE_GROUP } from './campaign-table-constants';

export const getViewTypeGroupBySlug = (slug: string) => VIEW_TYPE_GROUP
    .find(group => group.slug === slug);

export const isPlatformViewType = (slug: string) => Object.values(VIEW_TYPE)
    .includes(slug);
